"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const KeyboardArrowDown_1 = __importDefault(require("@material-ui/icons/KeyboardArrowDown"));
const KeyboardArrowUp_1 = __importDefault(require("@material-ui/icons/KeyboardArrowUp"));
const react_1 = require("react");
const components_1 = require("components");
const complete_check_svg_1 = __importDefault(require("images/utility-icons/complete_check.svg"));
const skipped_svg_1 = __importDefault(require("images/utility-icons/skipped.svg"));
const DetailsCollapse = ({ children, index, completeStatus, practiceName, isExpanded, setIsExpanded, singleDisplay, keepHeader = false, }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(isExpanded); // State - Local
    const toggleExpanded = () => {
        setIsOpen(!isOpen);
    };
    (0, react_1.useEffect)(() => {
        setIsExpanded(isOpen);
    }, [isOpen]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: `store-information-container ${singleDisplay && !keepHeader
            ? 'is-single-location'
            : 'is-multi-location'}`, children: [(0, jsx_runtime_1.jsxs)("div", { className: "store-information-header", "data-testid": `store-information-header-${index}`, onClick: toggleExpanded, role: "button", tabIndex: 0, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        toggleExpanded();
                    }
                }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "store-and-status", children: [completeStatus === 'incomplete' && ((0, jsx_runtime_1.jsx)("div", { className: "icon empty-circle" })), completeStatus === 'completed' && ((0, jsx_runtime_1.jsx)("img", { src: complete_check_svg_1.default, alt: "Location Completed", className: "icon" })), completeStatus === 'skipped' && ((0, jsx_runtime_1.jsx)("img", { src: skipped_svg_1.default, alt: "Location Completed", className: "icon" })), (0, jsx_runtime_1.jsx)(components_1.H3, { variant: "title-extra-large", children: practiceName })] }), isOpen ? ((0, jsx_runtime_1.jsx)(KeyboardArrowUp_1.default, { className: "arrow-icon", "data-testid": "arrow-up-icon" })) : ((0, jsx_runtime_1.jsx)(KeyboardArrowDown_1.default, { className: "arrow-icon", "data-testid": "arrow-down-icon" }))] }), isOpen ? children : null] }));
};
exports.default = DetailsCollapse;
